"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SortZASmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15.844187,12.1544192 C16.0326334,12.348329 16.0309924,12.6574627 15.8404979,12.849361 L13.5,15.2071068 L11.15264,12.8535278 C10.9596739,12.6600506 10.9593294,12.3470102 11.1518691,12.1531086 C11.3440776,11.9595407 11.6568113,11.9584386 11.8503792,12.1506471 L13,13.2928932 L13,4 L14,4 L14,13.2928932 L15.1583986,12.1475732 C15.3480406,11.9600722 15.6537754,11.9618079 15.8412764,12.1514499 L15.844187,12.1544192 Z M3,7 L3,6 L8.5,6 C8.83268738,5.9800415 9.19595337,6.41842651 8.8796283,6.82539569 L4.58711032,12 L9,12 L9,13 L3.5,13 C3.1203717,13 2.81752208,12.5670519 3.1203717,12.1746043 L7.41288968,7 L3,7 Z" })));
};
SortZASmall.displayName = 'SortZASmall';
exports.default = SortZASmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SortZASmall.js.map